import { render, staticRenderFns } from "./AssistMaterial.vue?vue&type=template&id=f055bf1e&scoped=true&lang=pug&"
import script from "./AssistMaterial.vue?vue&type=script&lang=ts&"
export * from "./AssistMaterial.vue?vue&type=script&lang=ts&"
import style0 from "./AssistMaterial.vue?vue&type=style&index=0&id=f055bf1e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f055bf1e",
  null
  
)

export default component.exports